module.exports = __webpack_public_path__ + "media/img/pages/profile/axpo ger 6-79fd97dd32afff4c66408a6dfc855b82.jpg";